import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { CountryItem, EnumMediaEntities, MediaTypeItem } from '../../../api/models';

export const commonActions = {
  loadCountries: createAction('load/countries'),
  doneLoadCountries: createAction(
    'load/countries/done',
    props<{ state: ILoaderActionPayload; data?: CountryItem[] }>(),
  ),
  loadMediaTypes: createAction('load/mediaTypes', props<{ entity: EnumMediaEntities }>()),
  doneMediaTypes: createAction(
    'load/mediaTypes/done',
    props<{ entity: EnumMediaEntities; state: ILoaderActionPayload; data?: MediaTypeItem[] }>(),
  ),
};
